//# sourceMappingURL=attribute.mjs.map
/// <reference types="./attribute.d.mts" />
import * as $attribute from "../../../redraw/dom/attribute.mjs";
import { attribute } from "../../../redraw/dom/attribute.mjs";

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Reference/Attribute/viewBox)
 */
export function viewbox(viewbox) {
  return attribute("viewBox", viewbox);
}

/**
 * [Documentation](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/fill)
 */
export function fill(fill) {
  return attribute("fill", fill);
}
